import ICONS from "../../assets/Icons";

const Loader = ({
  height = "var(--loader-lg)",
  width = "var(--loader-lg)",
  type,
}) => {
  const loaderStyle = {
    height,
    width,
  };
  return (
    <div
      className={` ${
        type === "bulk_upload" || type === "multiEntity"
          ? "flex items-center justify-center"
          : ""
      }`}
    >
      <img
        alt="data loader"
        src={ICONS?.LOADER_GIF}
        style={loaderStyle}
      />
    </div>
  );
};
export default Loader;
